import React from "react";
import { Logo } from "./Logo";

export function Header() {
  return (
    <header className="site-header">
      <div className="wrap header-inner">
        <Logo />
        <nav className="header-nav" aria-label="Navegación principal">
          <a href="/sobre-nosotros">Nosotros</a>
          <a href="/contacto">Contacto</a>
        </nav>
      </div>
    </header>
  );
}
